import { CONTACT_API } from 'modules/contacts/api/contact-api'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { SwrPaginationInterface } from 'shared/types/pagination-interface'
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string'
import useSWR from 'swr'
import { ContactId } from '../../types/contact-interface'
import { ContactAutomationTaskApiInterface } from '../types/contact-automation-task-interface'
import { ContactPageFilterInterface } from '../types/contact-page-filter-interface'

interface UseContactAutomationTasksInterface extends SwrPaginationInterface {
  contactId: ContactId
  filter: ContactPageFilterInterface
}

export function useContactAutomationTasks({
  limit,
  pagination,
  contactId,
  filter,
}: UseContactAutomationTasksInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ContactAutomationTaskApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const filterApi = `${filter.date[0] ? `&filter[dateSince]=${filter.date[0]}` : ''}${
    filter.date[1] ? `&filter[dateTill]=${filter.date[1]}` : ''
  }`

  const { data: contactAutomationTasks } = useSWR(() => {
    if (user) {
      return `${CONTACT_API}/${contactId}/automation-rules/list?${getPaginationQueryString({
        limit,
        pagination,
      })}${filterApi}`
    }
    return null
  }, fetcher)

  return { contactAutomationTasks }
}
